import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { GalleryImageItem } from "interfaces/ActivityInterfaces";

interface GalleryProps {
    images: GalleryImageItem[];
}

function Gallery({ images }: GalleryProps) {
    const reactImageGalleryImages = images.map((image) => ({
        original: image.url,
        thumbnail: image.urlThumb,
        description: image.caption,
    }));

    if (reactImageGalleryImages.length === 0) {
        return null;
    }
    
    return (
        <div className="aspect-ratio-box">
            <div className="aspect-ratio-box-content">
                <ImageGallery items={reactImageGalleryImages} />
            </div>
        </div>
    );
}

export default Gallery;